import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Sanitizes a string for use in HTTP headers (e.g., S3 metadata).
 * Removes control characters, newlines, non-ASCII characters, and other invalid header characters.
 * HTTP headers only support ISO-8859-1 (Latin-1) characters, but to be safe we restrict to ASCII.
 * 
 * @param value - The string to sanitize
 * @param maxLength - Optional maximum length (default: 2048, S3 metadata limit)
 * @returns Sanitized string safe for HTTP headers
 */
export function sanitizeHeaderValue(value: string, maxLength: number = 2048): string {
  if (!value) return ''
  
  let sanitized = value
    // Remove all non-ASCII characters (HTTP headers don't support them reliably)
    .replace(/[^\x20-\x7E]/g, '')
    // Remove any remaining control characters
    .replace(/[\x00-\x1F\x7F]/g, '')
    .trim()
  
  // If sanitization removed everything, return a fallback
  if (!sanitized) {
    return 'file'
  }
  
  // Truncate if too long (S3 metadata values have a 2KB limit)
  if (sanitized.length > maxLength) {
    sanitized = sanitized.substring(0, maxLength)
  }
  
  return sanitized
}
